import { motion, AnimatePresence } from "framer-motion";
import { useState, useEffect } from "react";

import hero1 from "./image/introduce/hero1.png";
import hero2 from "./image/introduce/hero2.png";
import hero3 from "./image/introduce/hero3.png";
import hero4 from "./image/introduce/hero4.png";

const heroImages = [hero1, hero2, hero3, hero4];

export default function HeroGallery() {
  const [index, setIndex] = useState(0);

  // Chuyển ảnh tự động mỗi 4 giây
  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % heroImages.length);
    }, 4000);
    return () => clearInterval(timer);
  }, []);

  return (
    <div className="relative flex justify-center items-center overflow-hidden h-[450px] md:h-[650px] bg-slate-900">
      <AnimatePresence mode="wait">
        <motion.img
          key={index}
          src={heroImages[index]}
          alt={`hero-${index}`}
          // Mobile: bỏ rounded, Desktop: giữ rounded nếu nằm trong khung
          className="absolute w-full h-full object-cover md:rounded-3xl shadow-2xl"
          
          // Hiệu ứng "Healing Zoom" thay cho lật 3D để phù hợp di động
          initial={{ 
            opacity: 0, 
            scale: 1.1 // Bắt đầu hơi to một chút
          }}
          animate={{ 
            opacity: 1, 
            scale: 1,
            transition: { duration: 1.5, ease: "easeOut" } 
          }}
          exit={{ 
            opacity: 0, 
            scale: 0.95,
            transition: { duration: 1, ease: "easeIn" } 
          }}
        />
      </AnimatePresence>

      {/* Lớp phủ Gradient phía dưới để chữ nổi bật hơn trên di động */}
      <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent pointer-events-none" />

      {/* Dòng chữ: Đã tinh chỉnh font size và padding cho Mobile */}
      <motion.div
        className="absolute bottom-[15%] md:bottom-[20%] text-center z-10 w-[90%] md:w-auto"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.5, duration: 1 }}
      >
        <div className="bg-white/10 backdrop-blur-md px-6 py-5 rounded-2xl border border-white/20 shadow-2xl">
          <h1 className="text-white font-black text-2xl sm:text-4xl md:text-6xl tracking-tighter uppercase leading-tight drop-shadow-lg">
            Đầu đội nắng lạ,<br />
            <span className="text-orange-400">chân đạp đất xa</span>
          </h1>
          <p className="text-white/80 text-[10px] md:text-xs font-bold tracking-[0.3em] uppercase mt-2">
            Leo Núi Việt Nam — Explore more
          </p>
        </div>
      </motion.div>

      {/* Chỉ báo trang (Dots) giúp khách biết có nhiều ảnh */}
      <div className="absolute bottom-6 flex gap-2 z-20">
        {heroImages.map((_, i) => (
          <div 
            key={i}
            className={`h-1.5 transition-all duration-500 rounded-full ${index === i ? 'w-8 bg-orange-400' : 'w-2 bg-white/50'}`}
          />
        ))}
      </div>
    </div>
  );
}